module.exports = __webpack_public_path__ + "static/media/corporate-logos.5b2990a2.png";